import type { GlobalStateMergedState } from 'components/GlobalState/GlobalStateModel';
import { selectAppInitialized } from 'components/GlobalState/selectors/selectAppInitialized';

export const selectAppLoading = (s: GlobalStateMergedState): boolean =>
  !selectAppInitialized(s) && !s.appLoadError;
